import { apply, compose, curry, fromPairs, toPairs, filter } from 'ramda';

export const filterWithKey = curry((fn, xs) => compose(fromPairs, filter(apply(fn)), toPairs)(xs));
